import axios, { AxiosInstance } from "axios";

const apiBase = process.env.REACT_APP_AUTH_API || "http://localhost:4100";
const baseURL = apiBase.startsWith("http") ? apiBase : `http://${apiBase}`;

const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("sso_user");

      const requestUrl = String(error.config?.url || "");
      const isLoginRequest =
        requestUrl.includes("/api/auth/login") ||
        requestUrl.includes("/auth/login");

      if (!isLoginRequest) {
        const currentParams = new URLSearchParams(window.location.search);
        const isAdminContext =
          window.location.pathname.startsWith("/admin") ||
          currentParams.get("mode") === "admin";
        const mode = isAdminContext ? "admin" : "user";

        if (
          window.location.pathname !== "/login" ||
          currentParams.get("mode") !== mode
        ) {
          window.location.href = `/login?mode=${mode}`;
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
